import Vue from 'vue'
import meta from '../../bankrate-tracking/meta'
import cookieEvent from './../bankrate-events'
import { getBrOption } from './../../bankrate-utilities'

window.dataLayer = window.dataLayer || []

let eachRecursive = function eachRecursive(obj, cb) {
  for (let k in obj) {
    if (!obj.hasOwnProperty(k)) {
      continue
    }

    if (typeof obj[k] === 'object' && obj[k] !== null) {
      eachRecursive(obj[k], cb)
    } else {
      if (cb) {
        cb(obj, k)
      }
    }
  }
}

let bankrateGaDataLayer = new Vue({
  data: function() {
    return {
      pid: 'br3'
    }
  },
  methods: {
    setInitDataLayer: function setDataLayer() {
      let newLayer = {
        adArea: 'AdArea',
        adKeywords: 'AdKeyword',
        primaryCategory: 'Category',
        cobrand: 'Site',
        pageType: 'PageType',
        subCategories: 'SubCategories',
        content: {
          author: 'Author',
          date: 'Published',
          funnelStage: 'FunnelStage',
          targetPersona: 'TargetPersona',
          objective: 'Objective',
          topic: 'Topic'
        }
      }
      eachRecursive(newLayer, function(obj, key) {
        let value = meta.getMetaData(obj[key])
        obj[key] = value && key !== 'title' ? value : null
      })
      newLayer.content.title = window.document.title
      newLayer.pageUX = meta.getPageUX()
      newLayer.environ = 'cb'
      newLayer.event = 'preload'

      window.dataLayer.push(newLayer)
    },
    injectGTM: function injectGTM() {
      // GTM injection moved to blade template gtm-snippet.blade.php
      cookieEvent.$emit('GTMReady')
    }
  }
})

let initEvent =
  getBrOption('GTMinitOn') !== null ? getBrOption('GTMinitOn') : 'pid.loaded'

cookieEvent.$once(
  initEvent,
  function(pid) {
    if (window === window.top) {
      this.pid = pid
      this.setInitDataLayer()
      this.injectGTM()
    }
  }.bind(bankrateGaDataLayer)
)

// TODO: make something more elegant
cookieEvent.$once(
  'ratetableError',
  function(pid) {
    if (window === window.top) {
      this.pid = pid
      this.setInitDataLayer()
      this.injectGTM()
    }
  }.bind(bankrateGaDataLayer)
)

export default bankrateGaDataLayer
